import React, { useContext } from 'react';
import { DropdownMenu } from '@paypalcorp/pp-react-dropdown-menu';
import { CustomColumn } from '@MerchantConfigurator/components/common';
import { MessagingAttributes, SelectionLabels } from '@MerchantConfigurator/constants';
import { ApplicationContext } from '@MerchantConfigurator/context';
import { getOptions } from '@MerchantConfigurator/utils/messaging';
import PropTypes from 'prop-types';
import styles from './ControlPanel.module.less';
import { trackFieldChange } from '../../../../../lib/fpti';

const BannerConfigs = ({ placement, placementConfig, updateConfig, updateCounters }) => {
  const eventCounter = `${placement}_configs_updated`;
  const { content, localeConfig } = useContext(ApplicationContext);

  return (
    <CustomColumn width="100%">
      <DropdownMenu
        className={styles.control_panel_dropdown_menu}
        label={content[SelectionLabels.color]}
        onChange={(event) => {
          updateConfig({
            placement,
            attribute: MessagingAttributes.color,
            value: event.target.value
          });
          trackFieldChange('Banner color', event.target.value);
          updateCounters(eventCounter);
        }}
        options={getOptions({
          attribute: MessagingAttributes.color,
          content,
          countryCode: localeConfig.countryCode
        })}
        value={placementConfig.color}
      />
      <DropdownMenu
        className={styles.control_panel_dropdown_menu}
        label={content[SelectionLabels.ratio]}
        onChange={(event) => {
          updateConfig({
            placement,
            attribute: MessagingAttributes.ratio,
            value: event.target.value
          });
          trackFieldChange('Banner size', event.target.value);
          updateCounters(eventCounter);
        }}
        options={getOptions({
          attribute: MessagingAttributes.ratio,
          content
        })}
        value={placementConfig.ratio}
      />
    </CustomColumn>
  );
};

export default BannerConfigs;

BannerConfigs.propTypes = {
  placement: PropTypes.string,
  placementConfig: PropTypes.object,
  updateConfig: PropTypes.func,
  updateCounters: PropTypes.func
};
